// @ts-nocheck

class UpcomingProductWaitlist extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
    this.form = null;
    this.thumbs = [];
    this.step1 = null;
    this.step2 = null;
  }

  connectedCallback() {
    this.cacheRefs();
    this.initSwiper();
    this.bindThumbnails();
    this.bindForm();
    this.bindSelects();
    this.bindDeposit();
    this.bindStep2();
    this.bindStep2Cta();
    this.maybeShowStep2OnLoad();
    this.maybeResumeAfterCustomerCreate();
  }

  maybeShowStep2OnLoad() {
    if (window.location.pathname === '/pages/ob1-utility-boot-waitlist-thank-you') {
      if (this.step1) this.step1.classList.add('upw__hidden');
      if (this.step2) this.step2.classList.remove('upw__hidden');
    }
  }

  // After the hidden customer-registration form does its real (non-AJAX) submit,
  // Shopify redirects back to this same page (return_to: 'back'). This resumes the
  // waitlist flow from where it left off: if the customer now exists, the account
  // was created successfully, so proceed to post the sheet row and show step 2.
  // If the customer doesn't exist, creation failed (e.g. duplicate email) — the
  // pending data is still posted to the sheet, since that flow must not be affected.
  maybeResumeAfterCustomerCreate() {
    const pendingRaw = window.sessionStorage.getItem('upwPendingPayload');
    if (!pendingRaw) return;
    window.sessionStorage.removeItem('upwPendingPayload');

    const intent = window.sessionStorage.getItem('upwPendingIntent') || 'submit';
    window.sessionStorage.removeItem('upwPendingIntent');

    let payload;
    try {
      payload = JSON.parse(pendingRaw);
    } catch (err) {
      return;
    }

    const customerCreated = this.dataset.customerLoggedIn === 'true';
    if (!customerCreated) {
      console.warn('[upcoming-product-waitlist] customer creation did not complete (duplicate email or validation error); continuing with sheet submission');
    }

    if (intent === 'deposit') {
      this.resumeDeposit(payload);
      return;
    }

    this.setSubmitting(true);
    this.postToSheet(payload)
      .then(() => this.showStep2())
      .catch((err) => console.warn('Waitlist submission failed:', err))
      .finally(() => this.setSubmitting(false));
  }

  disconnectedCallback() {
    this.destroySwiper();
  }

  cacheRefs() {
    this.form = this.querySelector('.upw__form');
    this.thumbs = Array.from(this.querySelectorAll('.upw__thumb'));
    this.step1 = this.querySelector('.upw__step-1');
    this.step2 = this.querySelector('.upw__step-2');
    this.submitBtn = this.querySelector('.upw__submit');
    this.depositBtn = this.querySelector('.upw__deposit');
    this.selects = Array.from(this.querySelectorAll('.upw__select'));
  }

  initSwiper() {
    const swiperEl = this.querySelector('.upw__swiper');
    if (!swiperEl) return;

    if (typeof window.Swiper === 'undefined') {
      this.swiperRetryCount = (this.swiperRetryCount || 0) + 1;
      if (this.swiperRetryCount > 50) return;
      this.swiperRetry = window.setTimeout(() => this.initSwiper(), 100);
      return;
    }

    this.swiperInstance = new window.Swiper(swiperEl, {
      slidesPerView: 1,
      loop: false,
      speed: 500,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      watchOverflow: true,
      touchEventsTarget: 'container',
      pagination: {
        el: this.querySelector('.upw__dots'),
        clickable: true,
        bulletClass: 'upw__dot',
        bulletActiveClass: 'upw__dot--active',
      },
      on: {
        slideChange: (swiper) => {
          this.syncActiveThumb(swiper.activeIndex);
          this.restartActiveFill();
          this.updateArrowsState(swiper);
        },
      },
    });

    this.bindArrows();
    this.updateArrowsState(this.swiperInstance);

    this.syncActiveThumb(0);
  }

  restartActiveFill() {
    const active = this.querySelector('.upw__dot--active');
    if (!active) return;
    active.classList.remove('upw__dot--active');
    void active.offsetWidth;
    active.classList.add('upw__dot--active');
  }

  bindArrows() {
    const buttons = this.querySelectorAll('[data-upw-nav]');
    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!this.swiperInstance) return;
        if (btn.dataset.upwNav === 'next') this.swiperInstance.slideNext();
        else this.swiperInstance.slidePrev();
      });
    });
  }

  updateArrowsState(swiper) {
    if (!swiper) return;
    const prevButtons = this.querySelectorAll('[data-upw-nav="prev"]');
    const nextButtons = this.querySelectorAll('[data-upw-nav="next"]');
    prevButtons.forEach((b) => b.classList.toggle('upw__arrow--disabled', !!swiper.isBeginning));
    nextButtons.forEach((b) => b.classList.toggle('upw__arrow--disabled', !!swiper.isEnd));
  }

  destroySwiper() {
    if (this.swiperRetry) {
      window.clearTimeout(this.swiperRetry);
      this.swiperRetry = null;
    }
    if (!this.swiperInstance) return;
    this.swiperInstance.destroy(true, true);
    this.swiperInstance = null;
  }

  bindThumbnails() {
    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = parseInt(thumb.dataset.thumbIndex || '0', 10);
        this.goToSlide(index);
      });
    });
  }

  goToSlide(index) {
    if (this.swiperInstance) this.swiperInstance.slideTo(index);
  }

  syncActiveThumb(activeIndex) {
    this.thumbs.forEach((thumb) => {
      const index = parseInt(thumb.dataset.thumbIndex || '0', 10);
      thumb.classList.toggle('upw__thumb--active', index === activeIndex);
    });
    this.scrollActiveMobileThumbIntoView(activeIndex);
  }

  scrollActiveMobileThumbIntoView(activeIndex) {
    const container = this.querySelector('.upw__thumbs-mobile');
    if (!container) return;
    const activeThumb = container.querySelector(`.upw__thumb[data-thumb-index="${activeIndex}"]`);
    if (!activeThumb) return;
    const containerRect = container.getBoundingClientRect();
    const thumbRect = activeThumb.getBoundingClientRect();
    const offset = thumbRect.left - containerRect.left
      - (containerRect.width / 2)
      + (thumbRect.width / 2);
    container.scrollTo({
      left: container.scrollLeft + offset,
      behavior: 'smooth',
    });
  }

  getSlideCount() {
    return this.querySelectorAll('.upw__swiper .swiper-slide').length || 1;
  }

  bindForm() {
    if (!this.form) return;
    this.form.addEventListener('submit', (event) => this.handleSubmit(event));
  }

  // Lets the browser perform a real, full-page submit of the create_customer form
  // (required for Shopify's CAPTCHA check to pass — it rejects programmatic/fetch
  // submissions). The payload is stashed in sessionStorage so it survives the
  // reload; maybeResumeAfterCustomerCreate() picks it up once Shopify redirects
  // back here and finishes the sheet-submission flow.
  // Deposit triggers the same native submit via requestSubmit() but has already
  // prepared its own payload/intent, so this is a no-op when that flag is set.
  handleSubmit(event) {
    if (this.depositSubmitInProgress) return;

    if (!this.validateForm()) {
      event.preventDefault();
      return;
    }

    const payload = this.buildPayload();
    this.populateCustomerFields(payload);
    window.sessionStorage.setItem('upwPendingPayload', JSON.stringify(payload));
    window.sessionStorage.setItem('upwPendingIntent', 'submit');

    this.setSubmitting(true);
    // No preventDefault(): the form submits natively so CAPTCHA validation succeeds.
  }

  populateCustomerFields(data) {
    const nameParts = (data.name || '').split(/\s+/).filter(Boolean);
    const firstName = nameParts[0] || '';
    const lastName = nameParts.slice(1).join(' ');
    const randomPassword = `Upw-${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;

    const tags = ['waitlist', 'ob1 utility boot waitlist', 'source-waitlist'];
    if (data.size) tags.push(`size-${data.size}`);
    if (data.color) tags.push(`color-${data.color}`);

    const firstNameField = this.form.querySelector('.upw__customer-first-name');
    const lastNameField = this.form.querySelector('.upw__customer-last-name');
    const tagsField = this.form.querySelector('.upw__customer-tags');
    const passwordFields = this.form.querySelectorAll('.upw__customer-password');

    if (firstNameField) firstNameField.value = firstName;
    if (lastNameField) lastNameField.value = lastName;
    if (tagsField) tagsField.value = tags.join(',');
    passwordFields.forEach((field) => { field.value = randomPassword; });
  }

  bindDeposit() {
    if (!this.depositBtn) return;
    this.depositBtn.addEventListener('click', (event) => this.handleDeposit(event));
  }

  // Validates all mandatory fields (name, email, size, color). Returns true when every
  // required field has a real value. Reports the first invalid field to the user.
  validateForm() {
    if (!this.form) return false;

    // Native constraint check first (handles email format, empty inputs, etc.).
    if (!this.form.checkValidity()) {
      this.form.reportValidity();
      return false;
    }

    // Explicitly require the selects to hold a real value (guards against a browser
    // auto-selecting the first option, which would otherwise pass checkValidity()).
    const requiredFields = ['name', 'customer[email]', 'size', 'color'];
    for (const fieldName of requiredFields) {
      const field = this.form.elements[fieldName];
      if (!field) continue;
      const value = (field.value || '').trim();
      if (value === '') {
        if (typeof field.reportValidity === 'function') {
          field.setCustomValidity('Please complete this field.');
          field.reportValidity();
          field.setCustomValidity('');
        }
        if (typeof field.focus === 'function') field.focus();
        return false;
      }
    }

    return true;
  }

  // Deposit Now: validate mandatory fields -> create the Shopify customer (real,
  // full-page submit for CAPTCHA) -> on return, save to sheet -> add $10 product ->
  // go to checkout. Since the customer form redirects back to this page, the
  // cart/checkout continuation happens in maybeResumeAfterCustomerCreate().
  handleDeposit(event) {
    event.preventDefault();
    if (!this.form) return;

    if (!this.validateForm()) return;

    const variantId = this.dataset.discountedVariantId;
    if (!variantId) {
      console.warn('[upcoming-product-waitlist] No discounted variant id provided');
      return;
    }

    const payload = this.buildPayload();
    this.populateCustomerFields(payload);
    window.sessionStorage.setItem('upwPendingPayload', JSON.stringify(payload));
    window.sessionStorage.setItem('upwPendingIntent', 'deposit');

    this.setButtonLoading(this.depositBtn, true);
    this.depositSubmitInProgress = true;
    this.form.requestSubmit();
  }

  // Runs the deposit continuation after returning from customer creation: save to
  // the sheet, add the $10 discounted product, then redirect straight to checkout.
  async resumeDeposit(payload) {
    const variantId = this.dataset.discountedVariantId;
    this.setButtonLoading(this.depositBtn, true);
    try {
      await this.postToSheet(payload);
      if (variantId) await this.ensureVariantQtyOne(variantId);
      window.location.href = `${window.Shopify?.routes?.root || '/'}checkout`;
    } catch (err) {
      console.error('[upcoming-product-waitlist] deposit flow failed', err);
      this.setButtonLoading(this.depositBtn, false);
    }
  }

  buildPayload() {
    const handle = this.dataset.productHandle || '';
    const storeOrigin = window.location.origin;
    const queryString = window.location.search;
    return {
      name: (this.form.elements.name?.value || '').trim(),
      email: (this.form.elements['customer[email]']?.value || '').trim().toLowerCase(),
      size: (this.form.elements.size?.value || '').trim(),
      color: (this.form.elements.color?.value || '').trim(),
      producturl: handle ? `${storeOrigin}/products/${handle}${queryString}` : '',
    };
  }

  async postToSheet(data) {
    const sheetUrl = this.dataset.sheetUrl || '';
    if (!sheetUrl) return;

    const formData = new FormData();
    Object.keys(data).forEach((key) => formData.append(key, data[key]));

    await fetch(sheetUrl, {
      method: 'POST',
      mode: 'no-cors',
      body: formData,
    });
  }

  setSubmitting(isSubmitting) {
    if (!this.submitBtn) return;
    if (isSubmitting) {
      this.submitBtn.setAttribute('disabled', 'true');
      this.submitBtn.classList.add('is-loading');
    } else {
      this.submitBtn.removeAttribute('disabled');
      this.submitBtn.classList.remove('is-loading');
    }
  }

  setButtonLoading(button, isLoading) {
    if (!button) return;
    if (isLoading) {
      button.setAttribute('disabled', 'true');
      button.classList.add('is-loading');
    } else {
      button.removeAttribute('disabled');
      button.classList.remove('is-loading');
    }
  }

  showStep2() {
    if (this.step1) this.step1.classList.add('upw__hidden');
    if (this.step2) this.step2.classList.remove('upw__hidden');
    if (this.step2) {
      this.step2.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    this.updateUrlForThankyou();
  }

  updateUrlForThankyou() {
    try {
      const url = new URL(window.location.href);
      const newPathname = url.pathname.replace(
        /ob1-utility-boot-waitlist(?!-thank-you)/,
        'ob1-utility-boot-waitlist-thank-you'
      );
      if (newPathname !== url.pathname) {
        url.pathname = newPathname;
        window.history.replaceState({}, '', url.toString());
      }
    } catch (err) {
      console.warn('[upcoming-product-waitlist] URL update failed:', err);
    }
  }

  bindSelects() {
    this.selects.forEach((select) => {
      this.toggleSelectFilled(select);
      select.addEventListener('change', () => this.toggleSelectFilled(select));
    });
  }

  toggleSelectFilled(select) {
    const filled = select.value !== '' && select.value != null;
    select.classList.toggle('upw__select--filled', filled);
  }

  bindStep2() {
    const skip = this.querySelector('.upw__skip');
    if (!skip) return;
    skip.addEventListener('click', (event) => {
      event.preventDefault();
      const redirect = (this.dataset.skipRedirect || '').trim();
      window.location.href = redirect || '/';
    });
  }

  bindStep2Cta() {
    const cta = this.querySelector('.upw__step-2-cta');
    if (!cta) return;
    cta.addEventListener('click', (event) => this.handleStep2Cta(event, cta));
  }

  async handleStep2Cta(event, cta) {
    event.preventDefault();
    const variantId = this.dataset.discountedVariantId;
    if (!variantId) {
      console.warn('[upcoming-product-waitlist] No discounted variant id provided');
      return;
    }

    this.setButtonLoading(cta, true);
    try {
      await this.ensureVariantQtyOne(variantId);
      window.location.href = `${window.Shopify?.routes?.root || '/'}checkout`;
    } catch (err) {
      console.error('[upcoming-product-waitlist] add to cart failed', err);
      this.setButtonLoading(cta, false);
    }
  }

  async ensureVariantQtyOne(variantId) {
    const root = window.Shopify?.routes?.root || '/';
    const id = Number(variantId);

    const cartRes = await fetch(`${root}cart.js`, {
      headers: { Accept: 'application/json' },
    });
    const cart = cartRes.ok ? await cartRes.json() : { items: [] };
    const existing = (cart.items || []).find((item) => item.variant_id === id);

    if (existing) {
      if (existing.quantity === 1) return;
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id, quantity: 1 }),
      });
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.message || 'cart/change.js failed');
      }
      return;
    }

    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [{ id, quantity: 1 }],
      }),
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || 'cart/add.js failed');
    }
  }
}

if (!customElements.get('upcoming-product-waitlist')) {
  customElements.define('upcoming-product-waitlist', UpcomingProductWaitlist);
}
